import type { KnowledgeResponse } from "entities/knowledge/types";
import type { ErrorMeta } from "types/redux";

export enum KnowledgeFeedActionTypes {
  FETCH_FOR_TOPIC = "entities/KNOWLEDGE_FEED_FETCH_FOR_TOPIC",
  FETCH_FOR_TOPIC_SUCCESS = "entities/KNOWLEDGE_FEED_FETCH_FOR_TOPIC_SUCCESS",
  FETCH_FOR_TOPIC_FAILURE = "entities/KNOWLEDGE_FEED_FETCH_FOR_TOPIC_FAILURE",
}

export type KnowledgeFeedFetchForTopicPayload = {
  content_type?: string;
  fromTime?: number;
  id: string;
  language?: string;
  limit: number;
  offset: number;
  publication_type?: string;
  search?: string;
  secondaryTopicId?: string | undefined;
  toTime?: number;
};

export type KnowledgeFeedFetchForTopicAction = {
  payload: KnowledgeFeedFetchForTopicPayload;
  type: KnowledgeFeedActionTypes.FETCH_FOR_TOPIC;
};

export type KnowledgeFeedFetchForTopicSuccessAction = {
  meta: KnowledgeFeedFetchForTopicPayload;
  payload: { data: KnowledgeResponse[]; topicId: string };
  type: KnowledgeFeedActionTypes.FETCH_FOR_TOPIC_SUCCESS;
};

export type KnowledgeFeedFetchForTopicFailureAction = {
  meta: KnowledgeFeedFetchForTopicFailureMeta;
  type: KnowledgeFeedActionTypes.FETCH_FOR_TOPIC_FAILURE;
};

type KnowledgeFeedFetchForTopicFailureMeta = ErrorMeta & { searchCriteria: KnowledgeFeedFetchForTopicPayload };

export type KnowledgeFeedAction =
  | KnowledgeFeedFetchForTopicAction
  | KnowledgeFeedFetchForTopicSuccessAction
  | KnowledgeFeedFetchForTopicFailureAction;
